import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import { EventDeliveryAddressFragmentDoc } from '../fragments/eventDeliveryAddress.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetDeliveryAddressesForEventQueryVariables = Types.Exact<{
  event_id: Types.Scalars['ID'];
}>;


export type GetDeliveryAddressesForEventQuery = { __typename?: 'Query', getDeliveryAddressesForEvent: Array<{ __typename?: 'EventDeliveryAddress', id: string, name?: string | null, event_id?: string | null, is_event_default: boolean, linked_item_location_count: number, additional_info?: string | null, streetname?: string | null, streetno?: string | null, city?: string | null }> };


export const GetDeliveryAddressesForEventDocument = gql`
    query GetDeliveryAddressesForEvent($event_id: ID!) {
  getDeliveryAddressesForEvent(event_id: $event_id) {
    ...EventDeliveryAddress
  }
}
    ${EventDeliveryAddressFragmentDoc}`;

/**
 * __useGetDeliveryAddressesForEventQuery__
 *
 * To run a query within a React component, call `useGetDeliveryAddressesForEventQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDeliveryAddressesForEventQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDeliveryAddressesForEventQuery({
 *   variables: {
 *      event_id: // value for 'event_id'
 *   },
 * });
 */
export function useGetDeliveryAddressesForEventQuery(baseOptions: Apollo.QueryHookOptions<GetDeliveryAddressesForEventQuery, GetDeliveryAddressesForEventQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDeliveryAddressesForEventQuery, GetDeliveryAddressesForEventQueryVariables>(GetDeliveryAddressesForEventDocument, options);
      }
export function useGetDeliveryAddressesForEventLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDeliveryAddressesForEventQuery, GetDeliveryAddressesForEventQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDeliveryAddressesForEventQuery, GetDeliveryAddressesForEventQueryVariables>(GetDeliveryAddressesForEventDocument, options);
        }
export type GetDeliveryAddressesForEventQueryHookResult = ReturnType<typeof useGetDeliveryAddressesForEventQuery>;
export type GetDeliveryAddressesForEventLazyQueryHookResult = ReturnType<typeof useGetDeliveryAddressesForEventLazyQuery>;
export type GetDeliveryAddressesForEventQueryResult = Apollo.QueryResult<GetDeliveryAddressesForEventQuery, GetDeliveryAddressesForEventQueryVariables>;